import type { VerticalMenuDataType, VerticalSubMenuDataType, VerticalMenuItemDataType } from '@/types/menuTypes'

export function hasPermission(permissions: string[], required: string): boolean {
  return permissions.includes(required)
}

export function filterMenuByPermission(
  items: VerticalMenuDataType[],
  canAccess: (permission: string) => boolean
): VerticalMenuDataType[] {
  return items.reduce<VerticalMenuDataType[]>((acc, item) => {
    const subMenuItem = item as VerticalSubMenuDataType
    const menuItem = item as VerticalMenuItemDataType

    if (menuItem.permission && !canAccess(menuItem.permission)) {
      return acc
    }

    if (subMenuItem.children) {
      const children = filterMenuByPermission(subMenuItem.children, canAccess)

      if (children.length === 0) {
        return acc
      }

      return [...acc, { ...subMenuItem, children }]
    }

    return [...acc, item]
  }, [])
}
